import { motion } from "framer-motion";

export function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative h-[42vh] sm:h-[52vh] min-h-[300px] sm:min-h-[380px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center scale-105" style={{ backgroundImage: `url(${image})` }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,10,12,0.55), rgba(11,10,12,0.9))" }} />
      <div className="absolute inset-0 vignette" />
      <motion.div
        initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.9 }}
        className="relative z-10 text-center px-6"
      >
        <p className="overline mb-4">{overline}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl gold-text tracking-tight mb-4">{title}</h1>
        {subtitle && <p className="text-sm sm:text-base text-[#D8D2CE] max-w-xl mx-auto leading-relaxed">{subtitle}</p>}
      </motion.div>
    </section>
  );
}

export function SectionTitle({ overline, title, className = "" }) {
  return (
    <div className={`text-center mb-12 ${className}`}>
      <p className="overline mb-3">{overline}</p>
      <h2 className="font-display text-3xl sm:text-4xl text-[#FBF8F5] tracking-tight">{title}</h2>
    </div>
  );
}
